import { takeIfIsNotNullOrEmpty } from "../utils"

export const transformPriceTable = (dataIn) => {
    if (!dataIn) {
        return undefined
    }
    const dataOut = {
        id: dataIn.id,
        name: dataIn.nome,
        type: dataIn?.tipo,
        maximumPeriod: dataIn?.periodoMaximo,
        maximumPrice: dataIn?.valorMaximo,
        additionalHourPrice: dataIn?.valorHoraAdicional,
        tolerance: takeIfIsNotNullOrEmpty(dataIn?.toleranciaPermanencia) ?? '0',
        tolerancePosPayment: takeIfIsNotNullOrEmpty(dataIn?.toleranciaPosPermanencia) ?? '0',
        chargeAdditionalHoursAfterMaximumPeriod: dataIn?.cobrarHorasAdicionaisAposPeriodoMaximo,
        chargeEarlyValuePermanence: dataIn?.cobrarAntecipadoValorPorPermanencia,
        periods: dataIn?.periodos?.map(e => {
            return {
                period: e.periodo,
                price: e.valor
            }
        })
    }
    return dataOut
}

export const transformPriceTables = (datasIn) => {
    const datasOut = datasIn.map(e => {
        return module.exports.transformPriceTable(e)
    })
    return datasOut
}